import { render, staticRenderFns } from "./OrdersTableAccount.vue?vue&type=template&id=d6ab63e6&"
import script from "./OrdersTableAccount.vue?vue&type=script&lang=js&"
export * from "./OrdersTableAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports